import React, { useState, useEffect } from "react";
import {
  Row,
  Col,
  Button,
  Card,
  Breadcrumb,
  Select,
  Form,
  Space,
  Input,
  Table,
  Avatar,
  Tabs,
  Dropdown,
  Modal,
  TextArea,
  Divider,
} from "antd";
import OpenNotificationWithIcon from "CommonComponents/ResultNotification/Notification";
import { Link, useParams, useNavigate } from "react-router-dom";
import {
  DoubleRightOutlined,
  PhoneOutlined,
  NumberOutlined,
  DownOutlined,
  PlusCircleOutlined,
  HomeFilled,
  HomeOutlined,
  BuildOutlined,
  MessageOutlined,
  MailFilled,
  MailOutlined,
  EyeOutlined,
  SettingOutlined,
  EnvironmentOutlined,
  UserOutlined,
  IdcardOutlined,
  MobileOutlined,
} from "@ant-design/icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faFileInvoice,
  faEnvelopeCircleCheck,
  faFile,
  faClock,
  faPhoneAlt,
  faBuilding,
  faUserAlt,
} from "@fortawesome/free-solid-svg-icons";
import {
  GetLeadsApi,
  GetLeadByIdApi,
  UpdateLeadApi,
  updateLeadStatusAPI,
} from "../LeadsAPI";
import { useSelector, useDispatch } from "react-redux";
import { getClientAPI, getStatusAPI } from "CommonComponents/Lookup/LookupAPI";
import { setLeadRecords } from "../LeadsSlice";
import LeadInfo from "./LeadInfo";
import { FormattedMessage, useIntl } from "react-intl";
import logoicon from "../../../logoicon.png";
import ActivitiesTab from "./LeadActivity";
import NotesTab from "../Components/NotesTab";
import FilesTab from "../Components/FilesTab";
import EmailTab from "../Components/EmailTab";
import CallsTab from "../Components/CallsTab";
import LeadCallItem from "../LeadCall/LeadCall";
import LeadNoteItem from "../LeadNote/LeadNote";
import LeadEmailItem from "../LeadEmail/LeadEmail";
import LeadFileList from "../LeadFile/LeadFile";
import LookupTypeEnum from "features/Enums/LookupTypeEnum";
function LeadView() {
  const [form] = Form.useForm();
  const intl = useIntl();
  const { leadId } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const LeadData = useSelector((state) => state.leads.leadRecords);
  const lead = useSelector((state) => state.leads.leadRecordById);
  const totalPages = useSelector((state) => state.leads.totalPages);
  const statusData = useSelector((state) => state.lookup.statusList);
  const companyNames = useSelector((state) => state.lookup.companyNames);
  const clients = useSelector((state) => state.lookup.clientList);
  const statusList = useSelector((state) => state.lookup.statusList);
  const companyServices = useSelector(
    (state) => state.lookup.lookupData[LookupTypeEnum.CompanyService.id]
  );
  const selectedLanguage = localStorage.getItem("selectedlanguage") || "fr-FR";
  const companyId = localStorage.getItem("CompanyId");
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [selectedStatus, setSelectedStatus] = useState(lead?.statusId);
  const [selectedLeadId, setSelectedLeadId] = useState(leadId);
  const [page, setPage] = useState(1);
  const [activeTab, setActiveTab] = useState("1");
  const [selected, setSelected] = useState("Closed");
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [rejectionReason, setRejectionReason] = useState("");
  const [pendingStatusId, setPendingStatusId] = useState(null);

  const statusColorsMap = {
    5: { color: "#4A90E2" }, // Open
    6: { color: "#6FCF97" }, // Closed
    7: { color: "#EB5757" }, // Rejected
  };
  const leadStatusList = statusList?.filter(
    (status) => status.type === "LeadStatus"
  );
  const items = leadStatusList?.map((status) => ({
    key: status.id,
    label: (
      <a
        href="#"
        onClick={(e) => {
          e.preventDefault();
          if (status.id !== selectedStatus) {
            if (
              (status.nameEn === "Rejected" || status.nameFr === "Rejeté") &&
              status.id !== selectedStatus
            ) {
              setPendingStatusId(status.id);
              setIsModalVisible(true);
            } else {
              setSelectedStatus(status.id);
              dispatch(updateLeadStatusAPI(leadId, status.id));
            }
          }
        }}
      >
        {selectedLanguage === "fr-FR" ? status.nameFr : status.nameEn}
      </a>
    ),
  }));
  const currentStatus = leadStatusList?.find((s) => s.id === selectedStatus);
  const currentStatusLabel =
    selectedLanguage === "fr-FR"
      ? currentStatus?.nameFr
      : currentStatus?.nameEn;
  const handleTabChange = (key) => {
    setActiveTab(key);
  };
  // // const handleSubmit = () => {
  // //   const updatedLead = {
  // //     ...lead,
  // //     statusId: selectedStatus,
  // //   };

  // //   dispatch(UpdateLeadApi(updatedLead))
  // //     .then(() => {
  // //       dispatch(GetLeadByIdApi(leadId));
  // //     })
  // //     .catch((error) => {
  // //       console.error("Error updating lead:", error);
  // //     });
  // // };
  // const pagination = {
  //   pageNo: currentPage,
  //   pageSize: 10,
  //   searchQuery: searchTerm,
  //   isSearch: searchTerm !== "",
  // };
  const handlePageChange = (page) => {
    setCurrentPage(page);
  };
  const handleSearch = (value) => {
    setSearchTerm(value);
    setCurrentPage(1);
  };
  const estimateStatusList = statusData?.filter(
    (status) => status.type === "EstimateStatus"
  );
  const handleEdit = (id) => {
    navigate(`/editLead/${id}`);
  };
  const statusColors = {
    1: "orange",
    2: "green",
    3: "red",
    4: "red",
  };
  const handleLeadSelection = (id) => {
    if (selectedLeadId !== id) {
      setSelectedLeadId(id);
      navigate(`/lead_view/${id}`);
    }
  };
  const onScroll = (e) => {
    const { scrollTop, scrollHeight, clientHeight } = e.currentTarget;

    if (scrollHeight - scrollTop <= clientHeight + 10) {
      setPage((prevPage) => {
        const nextPage = prevPage + 1;
        if (nextPage <= totalPages) {
          dispatch(
            GetLeadsApi({
              pageNo: nextPage,
              pageSize: 10,
              searchQuery: searchTerm,
            })
          );
        }
        return nextPage;
      });
    }
  };
  const formatPhoneNumber = (number) => {
    if (!number) return "N/A";
    const cleaned = String(number).replace(/\D/g, "");
    const match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
    if (match) {
      return `${match[1]}-${match[2]}-${match[3]}`;
    }
    return number;
  };
  const handleClick = () => {
    const hasAddress =
      lead?.deliveryAddress?.address1 ||
      lead?.deliveryAddress?.address2 ||
      lead?.deliveryAddress?.city ||
      lead?.deliveryAddress?.provinceName ||
      lead?.deliveryAddress?.zip ||
      lead?.deliveryAddress?.countryName;

    if (hasAddress) {
      navigate(`/${companyId}/${lead?.clientId}/client_details/addestimate`, {
        state: { leadId },
      });
    } else {
      OpenNotificationWithIcon(
        "warning",
        "Common.Warning",
        "",
        "LeadView.AddressRequired"
      );
    }
  };
  const handleClicked = () => {
    navigate(
      `/${companyId}/${lead?.clientId}/client_details/${lead?.estimateId}/viewquote`,
      {
        state: { leadId },
      }
    );
  };
  const handleRejectStatus = () => {
    if (pendingStatusId && rejectionReason.trim()) {
      dispatch(updateLeadStatusAPI(leadId, pendingStatusId, rejectionReason))
        .then(() => {
          setSelectedStatus(pendingStatusId);
          setIsModalVisible(false);
          setRejectionReason("");
        })
        .catch((error) => {
          console.error("Error updating rejected status:", error);
        });
    }
  };
  // const getWindowDimensions = () => {
  //   const { innerWidth: width, innerHeight: height } = window;
  //   return {
  //     width,
  //     height,
  //   };
  // };
  // const useWindowDimensions = () => {
  //   const [windowDimensions, setWindowDimensions] = useState(
  //     getWindowDimensions()
  //   );

  //   useEffect(() => {
  //     function handleResize() {
  //       setWindowDimensions(getWindowDimensions());
  //     }

  //     window.addEventListener("resize", handleResize);
  //     return () => window.removeEventListener("resize", handleResize);
  //   }, []);

  //   return windowDimensions;
  // };

  //const { height, width } = useWindowDimensions();
  // useEffect(() => {
  //   if (leadId) {
  //     setSelectedLeadId(leadId);
  //   }
  // }, [leadId]);
  // useEffect(() => {
  //   const isSearch = searchTerm !== "";
  //   if (!isSearch) {
  //     dispatch(
  //       setLeadRecords({ data: [], totalPages: 0, pageNo: 1, isSearch: true })
  //     );
  //   }
  //   dispatch(GetLeadsApi({ ...pagination, isSearch }));
  // }, [dispatch, currentPage, searchTerm]);
  // useEffect(() => {
  //   if (leadId) {
  //     dispatch(GetLeadByIdApi(leadId));
  //   }
  // }, [dispatch, leadId]);
  useEffect(() => {
    dispatch(getStatusAPI());
    dispatch(getClientAPI());
    dispatch(getStatusAPI());
  }, [dispatch]);
  useEffect(() => {
    if (lead && lead.statusId) {
      setSelectedStatus(lead.statusId);
      form.setFieldsValue({ Status: lead.statusId });
    }
  }, [lead]);

  return (
    <>
      <div className="medispamain" style={{ position: "relative" }}>
        <div className="main-area">
          <div className="title-part">
            <Row align="middle" justify="space-between" gutter={[16, 16]}>
              <Col xs={24} md={12} lg={12}>
                <h4>{<FormattedMessage id="Lead.LeadView" />}</h4>
                <p className="mt-5px">
                  <FormattedMessage id="Lead.Description" />
                </p>
              </Col>
              <Col
                xs={24}
                md={12}
                lg={12}
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                  alignItems: "center",
                  textAlign: "right",
                }}
              >
                <Breadcrumb
                  separator={<DoubleRightOutlined />}
                  items={[
                    {
                      title: <FormattedMessage id="Lead.Heading" />,
                      href: `/${companyId}/leads`,
                    },
                    {
                      title: <FormattedMessage id="Lead.LeadView" />,
                    },
                  ]}
                />
              </Col>
            </Row>
          </div>
          <Card className="clientview-new">
            <Row align="middle" gutter={[16, 16]}>
              <Col xs={24} sm={24} lg={13}>
                <div
                  style={{
                    display: "flex",
                    width: "100%",
                    alignItems: "center",
                    gap: 12,
                  }}
                >
                  {/* Avatar - Fixed width */}
                  <div style={{ width: 48 }}>
                    {lead?.leadType !== undefined && (
                      <Avatar
                        size={24}
                        style={{
                          backgroundColor:
                            lead.leadType === 1 ? "#1890ff" : "#52c41a",
                          fontSize: 12,
                          verticalAlign: "middle",
                          width: 48,
                          height: 48,
                          fontSize: 18,
                        }}
                      >
                        {lead.leadType == 1 ? (
                          <HomeOutlined />
                        ) : (
                          <FontAwesomeIcon icon={faBuilding} />
                        )}
                      </Avatar>
                    )}
                  </div>

                  <div style={{ flex: 1 }} className="leadtop">
                    <Link to={`/${companyId}/${lead?.clientId}/client_details`}>
                      <h4
                        className="word-break capi"
                        style={{
                          fontWeight: "bold",
                          marginBottom: 0,
                          fontSize: 20,
                        }}
                      >
                        {
                          clients?.find((c) => c.id === lead?.clientId)?.[
                            lead?.leadType === false ? "companyName" : "nameEn"
                          ]
                        }
                      </h4>
                    </Link>
                    <Space
                      direction="horizontal"
                      wrap
                      size={[8, 8]}
                      style={{
                        display: "flex",
                        flexWrap: "wrap", // ✅ allows stacking on small screens
                      }}
                    >
                      <p style={{ marginBottom: 0 }}>
                        {lead?.leadType === false && (
                          <>
                            <UserOutlined style={{ marginRight: 8 }} />
                            {lead?.name} &nbsp;&nbsp;|&nbsp;&nbsp;
                          </>
                        )}
                        <PhoneOutlined style={{ marginRight: 4 }} />
                        <a href={`tel:${lead?.mobileNumber}`}>
                          {formatPhoneNumber(lead?.mobileNumber)}
                        </a>
                      </p>

                      <p style={{ marginBottom: 0 }}>
                        <MailOutlined style={{ marginRight: 8 }} />
                        {lead?.email}
                      </p>
                    </Space>

                    <Space>
                      <p>
                        <EnvironmentOutlined style={{ marginRight: 8 }} />
                        <a
                          href={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(
                            [
                              lead?.deliveryAddress?.address1,
                              lead?.deliveryAddress?.address2,
                              lead?.deliveryAddress?.city,
                              lead?.deliveryAddress?.provinceName,
                              lead?.deliveryAddress?.countryName,
                              lead?.deliveryAddress?.zip,
                            ]
                              .filter(Boolean)
                              .join(", ")
                          )}`}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          {[
                            lead?.deliveryAddress?.address1,
                            lead?.deliveryAddress?.address2,
                            lead?.deliveryAddress?.city,
                            lead?.deliveryAddress?.provinceName,
                            lead?.deliveryAddress?.countryName,
                            lead?.deliveryAddress?.zip,
                          ]
                            .filter(Boolean)
                            .join(", ")}
                        </a>
                      </p>
                    </Space>
                  </div>
                </div>
              </Col>
              <Divider className="mt-0 mb-0 desktop-d-none" />
              <Col xs={24} sm={12} lg={6} align="left">
                <ul className="lead-right-list">
                  <li>
                    <UserOutlined />
                    &nbsp;
                    <FormattedMessage id="Leads.SalesPerson" />:{" "}
                    <b>{lead?.salesperson || "-"}</b>
                  </li>

                  <li>
                    <PhoneOutlined /> &nbsp;
                    <a href={`tel:${lead?.salesPersonPhone}`}>
                      {formatPhoneNumber(lead?.salesPersonPhone) || "-"}
                    </a>
                    &nbsp;&nbsp; | &nbsp;&nbsp;
                    <MailOutlined /> &nbsp;{lead?.salesPersonEmail || "-"}
                  </li>
                  <li>
                    <SettingOutlined />
                    &nbsp;&nbsp;Lead Service:&nbsp;&nbsp;&nbsp;
                    {
                      companyServices?.find(
                        (service) => service.id === lead?.companyServiceId
                      )?.nameEn
                    }
                  </li>
                </ul>
              </Col>
              <Divider className="mt-0 mb-0 desktop-d-none" />
              <Col
                xs={24}
                sm={12}
                lg={5}
                style={{ display: "flex", justifyContent: "flex-end" }}
              >
                <Space
                  size="small"
                  style={{
                    display: "flex",
                    flexWrap: "nowrap",
                    gap: 8,
                  }}
                >
                  <Dropdown menu={{ items }} trigger={["click"]}>
                    <Button
                      onClick={(e) => e.preventDefault()}
                      style={{
                        backgroundColor: statusColorsMap[selectedStatus]?.color,
                        color: "#fff",
                        border: "none",
                        whiteSpace: "nowrap",
                      }}
                    >
                      {currentStatusLabel || "Select Status"} <DownOutlined />
                    </Button>
                  </Dropdown>

                  {!lead?.estimateId && (
                    <Button
                      type="primary"
                      onClick={handleClick}
                      style={{
                        whiteSpace: "nowrap",
                      }}
                    >
                      <PlusCircleOutlined />
                      <FormattedMessage id="AddEstimate.AddEstimate" />
                    </Button>
                  )}

                  {lead?.estimateId && (
                    <Button
                      color="cyan"
                      variant="outlined"
                      onClick={handleClicked}
                      style={{
                        whiteSpace: "nowrap",
                      }}
                    >
                      <EyeOutlined />
                      <FormattedMessage id="Leads.ViewQuote" />
                    </Button>
                  )}
                </Space>
              </Col>
            </Row>
          </Card>
          <Row gutter={[16, 16]} className="mt-10">
            <Col xs={24} sm={24} md={10} lg={6}>
              {<LeadInfo />}
            </Col>
            <Col xs={24} sm={24} md={14} lg={18}>
              <Tabs defaultActiveKey="1" centered onChange={handleTabChange}>
                <Tabs.Item
                  tab={
                    <span>
                      <FontAwesomeIcon icon={faClock} />
                      &nbsp;{<FormattedMessage id="LeadActivity.Activities" />}
                    </span>
                  }
                  key="1"
                >
                  <ActivitiesTab />
                </Tabs.Item>
                <Tabs.Item
                  tab={
                    <span>
                      <FontAwesomeIcon icon={faFileInvoice} />
                      &nbsp;Notes
                    </span>
                  }
                  key="2"
                >
                  <NotesTab />
                </Tabs.Item>
                <Tabs.Item
                  tab={
                    <span>
                      <FontAwesomeIcon icon={faPhoneAlt} />
                      &nbsp;{<FormattedMessage id="Leads.Calls" />}
                    </span>
                  }
                  key="3"
                >
                  <CallsTab />
                </Tabs.Item>
                <Tabs.Item
                  tab={
                    <span>
                      <FontAwesomeIcon icon={faFile} />
                      &nbsp;{<FormattedMessage id="Leads.Files" />}
                    </span>
                  }
                  key="4"
                >
                  <FilesTab />
                </Tabs.Item>
                <Tabs.Item
                  tab={
                    <span>
                      <FontAwesomeIcon icon={faEnvelopeCircleCheck} />
                      &nbsp;{<FormattedMessage id="Leads.Emails" />}
                    </span>
                  }
                  key="5"
                >
                  <EmailTab />
                </Tabs.Item>
              </Tabs>
            </Col>
          </Row>
        </div>
      </div>
      <Modal
        title={<FormattedMessage id="Lead.RejectionReason" />}
        open={isModalVisible}
        onCancel={() => setIsModalVisible(false)}
        onOk={handleRejectStatus}
        okText={<FormattedMessage id="Common.Save" />}
        cancelText={<FormattedMessage id="Common.Cancel" />}
      >
        <Input.TextArea
          rows={4}
          maxLength={255}
          showCount
          placeholder={intl.formatMessage({
            id: "Lead.EnterReason",
          })}
          value={rejectionReason}
          onChange={(e) => setRejectionReason(e.target.value)}
        />
      </Modal>
    </>
  );
}

export default LeadView;
